import { onUnmounted, watch } from 'vue'
import Modal from 'src/components/form/fou-dialog/index.vue'
import { MdTypography, MdModal, MdButton, MdSpinner } from '@antiqua-dls/vue-components'
import { disableScrollOnModalOpen } from 'src/utils/helper/misc'

export default {
  components: {
    Modal,
    MdTypography,
    MdModal,
    MdButton,
    MdSpinner
  },
  props:{
    isModalOpen: {
      type: Boolean,
      default: false,
    },
    savingDraft: {
      type: Boolean,
      default: false,
    },
    modalId: {
      type: String,
      default: '',
    }
  },

  emits: ['closeModal', 'confirm'],

  setup(props){
    onUnmounted(() => {
      disableScrollOnModalOpen(false)
    })

    watch(() => props.isModalOpen, () => {
      disableScrollOnModalOpen(props.isModalOpen)
    })

    return {
    }
  }
}
